import { createFileRoute } from '@tanstack/react-router'
import PageEntrance from '~components/motion/page-entrance'
import Checkup from '~containers/app/ask-a-vet/4_checkup'

export const Route = createFileRoute(
  '/samsung/smart-things/(app)/ask-a-vet/preliminary-checkup/$main_concern/$symptom'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { main_concern, symptom } = Route.useParams()

  return (
    <PageEntrance key={`${main_concern}/${symptom}`}>
      <Checkup main_concern={main_concern} symptom={symptom} />
    </PageEntrance>
  )
}
